import { Item } from '../items'
import { Machine, LockerBox } from '../machines'
import { Order } from '../orders'
import { StationTranslation } from '../i18n'

export interface Station {
  id: number
  name: string
  nameAlias: string
  machine?: Machine
  extra: string
  fullAddress: string
  stationImageURL: string
  stationImageFileName: string
  mapImageURL: string
  mapImageFileName: string
  openingHours: string
  latitude: number
  longitude: number
  isClosed: boolean
  alertedEmergencies: Emergency[]
  items: StationItem[]
  foods: StationFood[]
  timeSlots: TimeSlot[]
  orders: Order[]
  placedDate: Date
  shippedDate: Date
  permittedDate: Date
  startOperationDate: Date
  lastOperationDate: Date
  removedDate: Date
  orderEnablingHours: string
  operationHours: string
  operationDays: string
  stationTranslations?: StationTranslation[]
  brand_code?: string // ブランドコード（admin権限のみ有効）
  recommendationItemCategory?: 'hot' | 'ice' | null
}

export interface Emergency {
  id: number
  stationID: number
  group: 'admin' | 'server' | 'hardware'
  message: string
  reportedAt: string
  canOpenLockerBox: boolean
}

export interface CoffeeLog {
  id: number
  makingStartedAt?: string
  makingDoneAt?: string
  lockerBox?: LockerBox
  item: Item
  willDisposedAt?: string
  servedAt?: string
  doorClosedAt?: string
  status: 'standby' | 'open' | 'closed' | 'failed'
  orderId?: number
  disposedAt?: string
}
export interface StationItem {
  id: number
  name: string
  cupType: number
  status: 'available' | 'unavailable' | 'unavailable_temporarily'
}

export interface StationFood {
  id: number
  name: string
  thumbnailImageURL?: string
  price: number
  status: 'available' | 'unavailable' | 'unavailable_temporarily'

}

export interface TimeSlot {
  id: number
  from: string
  to: string
  isClosed?: boolean
}

export enum StationImageType {
  StationImage = 'station_image',
  MapImage = 'map_image',
}

export interface StationImage {
  fileName?: string
  url?: string
  stationImageType?: StationImageType
}
